import React from 'react'
import GlobalCallbackStatusBadge from '../Badges/GlobalCallbackStatusBadges'

export function GlobalCallbackLogsTable ({ logs, loading, onView }) {
  return (
    <div className="table-responsive position-relative">
      {loading && (
        <div
          className="d-flex position-absolute top-0 start-0 w-100 h-100 align-items-center justify-content-center bg-opacity-75"
          style={{ zIndex: 5 }}
        >
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}

      <table className="table table-hover align-middle">
        <thead>
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th>Prefix</th>
            <th>Callback URL</th>
            <th>Status</th>
            <th style={{ width: 150 }}>Details</th>
          </tr>
        </thead>
        <tbody>
          {logs.length
            ? (
                logs.map((el) => (
              <tr key={el.id}>
                <td>{new Date(el.creation).toLocaleString('id-ID')}</td>
                <td>
                  <span className="status-secondary">{el.type || 'N/A'}</span>
                </td>
                <td>
                  <span className="text-primary fw-semibold">{el.prefix || '-'}</span>
                </td>
                <td className="text-break">
                  <code style={{ fontSize: '0.85em' }}>{el.callback_url}</code>
                </td>
                <td>
                  <GlobalCallbackStatusBadge statusCode={el.status_code} />
                </td>
                <td>
                  <div className="btn-group">
                    <button onClick={() => onView(el.id)} className="btn btn-sm btn-primary" title="View Details">
                      <i className="fa-solid fa-search" />
                    </button>
                  </div>
                </td>
              </tr>
                ))
              )
            : (
            <tr>
              <td colSpan={6} className="text-center text-muted py-5">
                <i className="fa-solid fa-inbox fa-2x mb-2 d-block" />
                No callback logs found for the selected filters.
              </td>
            </tr>
              )}
        </tbody>
      </table>
    </div>
  )
}

export default GlobalCallbackLogsTable
